module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/ig-images/ig-01-78b328bb0d9c6aa886c49ccbae214c73.jpg";